import { LockKeyhole, X } from "lucide-react";

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSignIn: (email: string) => void;
}

export function AuthModal({ isOpen, onClose, onSignIn }: AuthModalProps) {
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" role="presentation">
      <section className="auth-modal" role="dialog" aria-modal="true" aria-labelledby="auth-title">
        <button className="modal-close" onClick={onClose} type="button" aria-label="Close sign in">
          <X size={20} aria-hidden="true" />
        </button>
        <span className="auth-icon" aria-hidden="true">
          <LockKeyhole size={24} />
        </span>
        <h2 id="auth-title">Parent sign in</h2>
        <p>
          Use a parent email to open the Nesty Learning demo session. Production accounts can connect to the
          existing Nesty.family account service when that endpoint is available.
        </p>
        <form
          className="auth-form"
          onSubmit={(event) => {
            event.preventDefault();
            const data = new FormData(event.currentTarget);
            const email = String(data.get("email") ?? "").trim();
            if (email) onSignIn(email);
          }}
        >
          <label htmlFor="signin-email">Parent account email</label>
          <input id="signin-email" name="email" type="email" placeholder="parent@example.com" autoComplete="email" required />
          <button className="primary-button" type="submit">
            Sign in
          </button>
        </form>
      </section>
    </div>
  );
}
